module.exports = __webpack_public_path__ + "img/1f53aa7.jpg";